<template>
<div class="grid"  @click="edit">
<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{title}}:</p>
</div>


<template v-if="editing">
<div class="col-9 md:col-10 mt-3">
<div class="grid"  >
<div class="col">

<TreeSelect v-model="inputdata" 
:options="categoriesparsed"    
:placeholder="title" 
class="w-full p-inputtext-sm animate_class" 
@change="submitChanges" 
ref="inputarea"
>
	
</TreeSelect>

</div>
<div class="col-fixed " style="width:110px">
<Button type="button"  icon="pi pi-check" @click="submitChanges" class="p-button-primary p-button-outlined p-button-sm mr-2"  :loading="$store.state.ui.submitting" />
<Button type="button"  icon="pi pi-times" @click="cancel" class="p-button-danger p-button-outlined p-button-sm "  :loading="$store.state.ui.submitting" />
</div>
</div>
</div>
</template>

<template v-if="!editing">	
<div class="col-9 md:col-10">
<p class="click_edit_value animate_class">
{{displayvalue}}
</p>
</div>
</template>

</div>	
</template>

<script>
export default {

  name: 'ClickEditCategory',
  props:["title","value","valkey","read_only","allcategories"],
  data () {
    return {
    	editing:false,
    	inputdata:null,
    }
  },
  computed:{
    readonly()
    {
      
      if(this.read_only)
      {
        return true
      }
      return false
    },
    displayvalue()
    {
    	let item = this.allcategories.find((element)=>{return element.id == this.value})
      if(item)
      {
          if(item.translations.length)
          {
            let translation =  item.translations.find((element)=>{return element.language_id ==  this.$store.state.auth.user.preflang_id})
            return translation.translation
          }
          else
          {
            return item.name
          }
         return item.name
      }
      return ""

    	
    	
    },
    categoriesparsed()
    {
    	console.log("categoriesparsed")
    	console.log(this.allcategories)
    	let category_set = []
    	let parent_categories = this.allcategories.filter((item)=>{return item.customattributecategory_id ===0})
    	for(let parent_category of parent_categories)
    	{
    		console.log("parent_category")
    		console.log(parent_category)
    		let children = this.findChildren(parent_category.id)
    		console.log("children")
    		console.log(children)
    		parent_category.children = children
    		parent_category.key = parent_category.id
    		parent_category.label = parent_category.name
    		parent_category.data = parent_category.id
    		category_set.push(parent_category)
    	}
    	console.log("category_set")
    	console.log(category_set)
    	return category_set

    },
  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		 console.log("value change");
  		 this.editing = false
  	}
  },
  methods:{
  	findChildren(category_id)
  	{
  		console.log("findChildren")
  		let children = this.allcategories.filter((item)=>{return item.customattributecategory_id ===category_id})
  		for(let child of children)  		
  		{
  			child.children = this.findChildren(child.id)  			
    		child.key = child.id
    		child.label = child.name
    		child.data = child.id
  		}
  		return children
  	},
  	submitChanges()
  	{
  		
  		let the_key = Object.keys(this.inputdata)[0]
  			

  		if(the_key !==this.value)
  		{
  			this.$emit("dataChanged",{value:the_key,key:this.valkey})
  			this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
  	edit()
  	{
      if(this.readonly)
      {
        return false
      }

      if(!this.editing)
      {
        this.editing = true
        this.inputdata = this.value
        
        setTimeout(()=>{
          if(this.$refs.inputarea)
          {
            this.$refs.inputarea.$el.focus()
          }
          
        },10)
      }
  		
  		
  	},
  	cancel()
  	{
      console.log("cancelll")
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
</style>